module.exports = __webpack_public_path__ + "img/icon--chevron-right.8d91b7b8.svg";